<template>
  <a-modal
    class="select-role-modal"
    width="700px"
    v-model:visible="rolesVisible"
    title="选择角色"
    :closable="false"
    :keyboard="false"
    :maskClosable="false"
    :afterClose="() => { commitRoleVisible(false) }"
    @ok="onSubmit"
    @cancel="closeModal">
    <div class="role-item"
      v-for="(item, index) in optionalRoles"
      :key="index"
      @click="activeRole = item">
      <div class="role-radio-wrap"
        :class="{
          'active-role': activeRole === item
        }">
        <div class="role-radio"></div>
      </div>
      <p class="role-text">{{ getCompanyName(item.companyId) }}</p>
      <p class="role-text">{{ getTeamName(item.teamId) }}</p>
      <p class="role-text">{{ getRoleName(item.roleId) }}</p>
    </div>
  </a-modal>
</template>
<script>
import { switchRole } from '@/api/user'
import { mapState } from 'vuex'
import { getCompanyName, getTeamName, getRoleName } from '@/filters'
export default {
  data () {
    return {
      activeRole: null
    }
  },
  computed: {
    ...mapState(['optionalRoles', 'rolesVisible', 'currentRole'])
  },
  watch: {
    rolesVisible (val) {
      if (val) {
        if (this.currentRole && this.currentRole.roleId) {
          this.activeRole = this.currentRole
        }
      }
    }
  },
  methods: {
    getCompanyName,
    getTeamName,
    getRoleName,
    commitRoleVisible (bool) {
      this.$store.commit('setRolesVisible', bool)
    },
    onSubmit () {
      if (this.activeRole && this.activeRole.roleId) {
        const { roleId, companyId, teamId } = this.activeRole
        console.log(teamId)
        this.loading = true
        switchRole({
          roleId,
          companyId,
          teamId: teamId || ''
        }).then(res => {
          this.$store.commit('setCurrentRole', this.activeRole)
          this.$store.dispatch('updateTeamList')
          localStorage.setItem('westCurrentRole', JSON.stringify({ roleId, companyId, teamId }))
          this.commitRoleVisible(false)
        }).finally(() => {
          this.loading = false
        })
      }
    },
    closeModal () {
      if (this.currentRole && this.currentRole.roleId) {
        this.commitRoleVisible(false)
      } else {
        this.$message.warning('请选择角色')
      }
    }
  }
}
</script>
<style lang="less">
.select-role-modal {
  .role-item {
    display: flex; align-items: center;
    .role-text {
      width: 200px; text-align: left;
    }
    .role-radio-wrap {
      margin-right: 20px;
      width: 12px; height: 12px;
      border: 1px solid #999;
      box-sizing: content-box;
      border-radius: 7px;
      cursor: pointer;
      .role-radio {
        margin: 2px;
        width: 8px; height: 8px;
        border-radius: 4px;
        background: #fff;
      }
      &.active-role {
        border: 1px solid #0C2366;
        .role-radio {
          background: #0C2366
        }
      }
    }
  }
}
</style>
